import React from "react";
import { t } from "../i18n";
import { isChunkLoadError } from "../utils/lazyWithRetry";

// Перехватчик ошибок отрисовки. Без него любая ошибка при показе раздела
// снимала с экрана всё приложение — оставался чёрный экран, который лечила
// только перезагрузка. Теперь вместо упавшего раздела — карточка с
// объяснением и кнопками; соседние разделы и навигация работают.
//
// fullScreen — для корня приложения; silent — для украшений: упали — ничего
// не показываем.
export default class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] раздел не отрисовался:", error, info?.componentStack || "");
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.silent) return null;
    const outdated = isChunkLoadError(error);
    return (
      <div className={`kl-crash${this.props.fullScreen ? " is-full" : ""}`} role="alert">
        <div className="kl-crash-card">
          <span className="kl-crash-icon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-3-6.7L21 8" /><path d="M21 3v5h-5" />
            </svg>
          </span>
          <div className="kl-crash-title">{this.props.fullScreen ? t("Панель не открылась") : t("Раздел не открылся")}</div>
          <div className="kl-crash-text">
            {outdated
              ? t("Панель обновилась, пока страница была открыта. Обновите страницу — всё загрузится заново.")
              : t("Что-то пошло не так при показе. Попробуйте ещё раз или обновите страницу.")}
          </div>
          <div className="kl-crash-actions">
            {/* Незагрузившийся файл раздела React запоминает — «ещё раз» тут
                не поможет, только обновление страницы. */}
            {!this.props.fullScreen && !outdated && (
              <button type="button" className="kl-crash-btn" onClick={() => this.setState({ error: null })}>
                {t("Попробовать снова")}
              </button>
            )}
            <button type="button" className="kl-crash-btn is-primary" onClick={() => window.location.reload()}>
              {t("Обновить страницу")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
